/**
 * components/txn · MES Transaction UI Kit (PRESENTATION ONLY)
 * ----------------------------------------------------------------
 * PMS transaction UI design-system PILOT (see /app/memory/MES_UI_STANDARD.md).
 * Design tokens + interaction language are derived from the Sales Order
 * "Add Entry" screen. These primitives carry ZERO business logic, ZERO
 * API/stock-engine/lifecycle/validation behaviour — callers own all of that.
 *
 * NOTE: This is the initial pilot, NOT the final global UI benchmark.
 */
export { default as TransactionSection } from "./TransactionSection";
export { default as FormField } from "./FormField";
export { default as NumericField } from "./NumericField";
export { default as ReferenceSelect } from "./ReferenceSelect";
export { default as ReadOnlyField } from "./ReadOnlyField";
export { default as TransactionActionBar } from "./TransactionActionBar";
export { default as TransactionSummary } from "./TransactionSummary";

// Shared control classes — the ONE place editable-field styling lives so the
// whole transaction surface stays visually consistent (SO token language).
export const txnInputCls =
  "w-full h-9 px-3 bg-[var(--bg-0)] border border-[var(--border)] rounded-sm text-sm text-[var(--fg-0)] placeholder:text-[var(--fg-3)] focus:outline-none focus:border-[var(--accent)] transition-colors";
export const txnTextareaCls =
  "w-full min-h-[64px] px-3 py-2 bg-[var(--bg-0)] border border-[var(--border)] rounded-sm text-sm text-[var(--fg-0)] placeholder:text-[var(--fg-3)] focus:outline-none focus:border-[var(--accent)] transition-colors resize-y";

// Controlled button widths (REV-C §19) — avoid arbitrary per-screen widths.
export const txnBtnSize = {
  standard: "min-w-[112px]",
  medium: "min-w-[140px]",
  wide: "px-6",
};

// Action-bar button hierarchy (presentation only).
export const txnBtn = {
  primary:
    "inline-flex items-center justify-center gap-2 h-9 px-5 rounded-sm text-sm font-semibold text-white bg-[var(--accent)] hover:brightness-110 disabled:opacity-40 disabled:cursor-not-allowed transition",
  secondary:
    "inline-flex items-center justify-center gap-2 h-9 px-4 rounded-sm text-sm font-medium text-[var(--fg-0)] bg-[var(--bg-2)] border border-[var(--border)] hover:border-[var(--border-strong)] disabled:opacity-40 disabled:cursor-not-allowed transition",
  ghost:
    "inline-flex items-center justify-center gap-2 h-9 px-3 rounded-sm text-sm font-medium text-[var(--fg-1)] hover:text-[var(--fg-0)] hover:bg-[var(--bg-2)] disabled:opacity-40 disabled:cursor-not-allowed transition",
};
